import { render, staticRenderFns } from "./PlanetDistanceChart.vue?vue&type=template&id=bfa34fe2"
import script from "./PlanetDistanceChart.vue?vue&type=script&lang=js"
export * from "./PlanetDistanceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports